import React from "react";
import Milestone from "../Milestone/Milestone";
import { useTournamentAuth } from "../../utils/authorization";

const TournamentProgressSidebar = ({ tournamentId }) => {
  const { canManage } = useTournamentAuth(tournamentId);

  return (
    <div className="card-board p-6">
      <h2 className="heading-display text-xl mb-4">Tournament Progress</h2>
      <Milestone tournamentId={tournamentId} canManage={canManage} />
    </div>
  );
};

export default TournamentProgressSidebar;
